import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { useGraphQL } from "@/hooks/use-graphql";
import { EditPersonalDataForm } from "@/components/profile/personal-data/edit-personal-data-form";

import type { JSX } from "react";

const EditPersonalDataPageQuery = graphql(/* GraphQL */ `
  query EditPersonalDataPageQuery {
    ...EditPersonalDataFormFragment
  }
`);

const EditPersonalDataPage = (): JSX.Element => {
  const queryResult = useGraphQL(EditPersonalDataPageQuery, {});
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Dados Pessoais" align="center" />
      </HeaderRoot>
      <Page className="px-6 py-8">
        <AsyncDataWrapper {...queryResult}>
          {data ? <EditPersonalDataForm data={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/profile/personal-data/edit")({
  component: EditPersonalDataPage,
});
